export default __webpack_public_path__ + "static/media/spinner.2a41de0e.gif";